import React, { useState, useMemo } from "react";
import { NavLink } from "react-router-dom";

const cardStyle = {
  background: "#ffffff",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  padding: "20px",
  marginBottom: "20px",
};

const teal = "#06d1c6";

const inputStyle = {
  padding: "8px 12px",
  border: `1px solid ${teal}`,
  borderRadius: "6px",
  fontSize: "14px",
  width: "100%",
  maxWidth: "100%",
};

function formatDateForDisplay(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
}

export default function CreateClientBill() {
  const [clientType, setClientType] = useState("familyHead"); // "familyHead" | "investor"
  const [searchValue, setSearchValue] = useState("");
  const [billingFrom, setBillingFrom] = useState("2026-01-01");
  const [billingTo, setBillingTo] = useState("2026-01-31");

  const billDescription = useMemo(() => {
    const from = formatDateForDisplay(billingFrom);
    const to = formatDateForDisplay(billingTo);
    return from && to ? `For the period ${from} to ${to}` : "";
  }, [billingFrom, billingTo]);

  return (
    <div className="main-content">
      <div className="page-wrapper page-settings">
        <div className="content">
          <div style={cardStyle}>
            <div className="content-page-header content-page-headersplit">
              <h5>Create Client Bill</h5>
            </div>
            <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none", marginBottom: "20px" }}>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <NavLink to="/dashboard">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item">
                  <NavLink to="/admin/billing/create-client-bill">Billing</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Create Client Bill
                </li>
              </ol>
            </nav>

            {/* Client Type */}
            <div className="mb-3">
              <div className="d-flex gap-4">
                <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer", fontSize: "14px", color: "#334155" }}>
                  <input
                    type="radio"
                    name="clientType"
                    checked={clientType === "familyHead"}
                    onChange={() => setClientType("familyHead")}
                    style={{ accentColor: teal, width: "18px", height: "18px" }}
                  />
                  Family Head
                </label>
                <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer", fontSize: "14px", color: "#334155" }}>
                  <input
                    type="radio"
                    name="clientType"
                    checked={clientType === "investor"}
                    onChange={() => setClientType("investor")}
                    style={{ accentColor: teal, width: "18px", height: "18px" }}
                  />
                  Investor
                </label>
              </div>
            </div>

            {/* Family Head / Client search + Billing Period row */}
            <div className="row g-3 mb-3">
              <div className="col-12 col-md-6">
                <label className="form-label mb-1" style={{ fontSize: "14px", color: "#334155" }}>
                  {clientType === "familyHead" ? "Family Head" : "Investor"} :
                </label>
                <input
                  type="text"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  placeholder="Type to Search..."
                  style={inputStyle}
                  aria-label={clientType === "familyHead" ? "Family Head search" : "Investor search"}
                />
              </div>
              <div className="col-12 col-md-6">
                <label className="form-label mb-1" style={{ fontSize: "14px", color: "#334155" }}>Billing Period:</label>
                <div className="d-flex align-items-center gap-2 flex-wrap">
                  <div className="d-flex align-items-center flex-1" style={{ minWidth: "140px" }}>
                    <i className="fa fa-calendar-alt me-2" style={{ color: teal, fontSize: "14px" }} aria-hidden />
                    <input
                      type="date"
                      value={billingFrom}
                      onChange={(e) => setBillingFrom(e.target.value)}
                      style={{ ...inputStyle, flex: 1 }}
                      aria-label="Billing period start"
                    />
                  </div>
                  <span className="text-muted" style={{ fontSize: "14px" }}>-</span>
                  <div className="d-flex align-items-center flex-1" style={{ minWidth: "140px" }}>
                    <input
                      type="date"
                      value={billingTo}
                      onChange={(e) => setBillingTo(e.target.value)}
                      style={{ ...inputStyle, flex: 1 }}
                      aria-label="Billing period end"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Bill Description */}
            <div className="mb-4">
              <label className="form-label mb-1" style={{ fontSize: "14px", color: "#334155" }}>Bill Description</label>
              <input
                type="text"
                value={billDescription}
                readOnly
                style={{ ...inputStyle, background: "#f8fafc" }}
                aria-label="Bill description"
              />
            </div>

            {/* Show button */}
            <div className="text-center">
              <button
                type="button"
                className="border-0 rounded px-4 py-2"
                style={{ background: teal, color: "#fff", fontWeight: 600, fontSize: "14px", cursor: "pointer" }}
              >
                Show
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
